/**
 * 方法说明 <br />
 * author: CQS <br />
 * description: 数据分页。用于本地分页
 * @param {Array} data: 需要分页的数据
 * @param {object} pageInfo: 分页信息——{page：页面；size：每页条数；total：数据总数}
 * @param {object} allocation: 分页字段配置，可以配置不同的字段。默认值{page: 'page',size: 'size',total: 'total'}
 * @return {Array} 分页之后的数据
 * @createTime: 2024-03-29 15:34:28
 */
export const dataPaging = (
    data = [],
    pageInfo = {},
    allocation = {
        page: "page",
        size: "size",
        total: "total",
    }
) => {
    let result = [];
    let status = true;
    if (!data || !pageInfo || !allocation) {
        console.error("请检查传入值！");
        status = false;
    } else if (!Array.isArray(data)) {
        console.error("第一个参数应为数组");
        status = false;
    } else if (typeof pageInfo != "object") {
        console.error("第二个参数应为对象");
        status = false;
    } else if (typeof allocation != "object") {
        console.error("第三个参数应为对象");
        status = false;
    } else {
        let keys = Object.keys(pageInfo);
        for (let k in allocation) {
            if (!keys.includes(allocation[k])) {
                console.error("第三个参数对象value值应为第二个对象参数的key——key：" + k + "，value：" + allocation[k]);
                status = false;
            }
        }
    }
    if (status) {
        let allData = deepCopy(data);
        let pageKey = allocation["page"];
        let sizeKey = allocation["size"];
        let totalKey = allocation["total"];
        let start = (pageInfo[pageKey] - 1) * pageInfo[sizeKey];
        let end = pageInfo[pageKey] * pageInfo[sizeKey];
        if (start > pageInfo[totalKey]) {
            result = [];
        } else {
            if (end > pageInfo[totalKey]) {
                end = pageInfo[totalKey];
            }
            result = allData.slice(start, end);
        }
    }

    return result;
};
/**
 * 方法说明
 * author: CQS
 * description: 自定义深拷贝混合数据对象
 * @param {object} obj{object} 需要深拷贝的数据
 * @return {object,string} 深拷贝好的数据
 * @createTime: 2023-02-24 14:46:55
 */
export const deepCopy = function (obj) {
    let type = Object.prototype.toString.call(obj)
    if (type == "[object Array]") {
        let backObj = [];
        for (let val of obj) {
            backObj.push(deepCopy(val))
        };
        return backObj;
    }
    if (type == "[object Object]") {
        let backObj = {};
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                backObj[key] = deepCopy(obj[key])
            }
        };
        return backObj;
    }
    return obj;
};